import { Component, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { ComponentModule } from '@app/component/component.module';
import { SearchOperator } from '@core/base/objects/search/search-operator.enum';
import { Pagination } from '@core/objects/pagination';
import { SortOrder } from '@core/objects/sort-order';
import { RestSearchUtil } from '@core/utils/rest-search-util';
import { Donation } from '@shared/donation/donation';
import { DonationApi } from '@shared/donation/donation-api.service';
import { DonationSort } from '@shared/donation/donation-sort.util';
import moment from 'moment';

@Component({
  selector: 'app-stopped-donations-widget',
  templateUrl: './stopped-donations-widget.component.html',
  styleUrls: ['./stopped-donations-widget.component.scss'],
  imports: [ComponentModule],
})
export class StoppedDonationsWidgetComponent implements OnInit {
  stoppedDonations!: Donation[];

  constructor(private readonly donationApi: DonationApi) {}

  ngOnInit(): void {
    const filter = RestSearchUtil.createSearchFieldGroup([
      {
        fieldName: 'stopOnDate',
        operator: SearchOperator.GE,
        value: moment().add(-7, 'days').valueOf(),
      },
      {
        fieldName: 'paymentFrequency',
        operator: SearchOperator.NE,
        value: 'ONCE',
      },
    ]);
    const pagination = new Pagination(0, 100, new SortOrder('stopOnDate', 'desc'));

    this.donationApi.findByRequest(filter, pagination).subscribe(searchResult => {
      this.stoppedDonations = searchResult.content;
    });
  }

  sortDonations(sortEvent: Sort): void {
    if (!this.stoppedDonations) {
      return;
    }

    const data = this.stoppedDonations.slice();
    if (!sortEvent.direction) {
      this.stoppedDonations = data;

      return;
    }

    let sortFn: ((a: Donation, b: Donation) => number) | undefined;
    switch (sortEvent.active) {
      case 'donor.name.name':
        sortFn = DonationSort.byFullName;
        break;
      case 'donor.emailAddress':
        sortFn = DonationSort.byEmailAddress;
        break;
      case 'amount':
        sortFn = DonationSort.byAmount;
        break;
      case 'frequency':
        sortFn = DonationSort.byFrequency;
        break;
      case 'stopOnDate':
        sortFn = DonationSort.byStopOnDate;
        break;
    }

    if (sortFn !== undefined) {
      data.sort(sortFn);
      if (sortEvent.direction === 'desc') {
        data.reverse();
      }
    }

    this.stoppedDonations = data;
  }
}
